import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginUser, resetUserLogin } from "../features/user/userSlice";

const LoginScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // states
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState("password");

  // selectors
  const {
    userInfo,
    isLoginLoading,
    isLoginError,
    isLoginSuccess,
    loginErrorMessage,
  } = useSelector((state) => state.user);

  const redirect = "/";

  // effects
  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [userInfo, redirect, navigate]);

  useEffect(() => {
    if (isLoginSuccess) {
      toast.success("Login Successful", {
        position: "top-center",
      });
      navigate("/");
    }
    if (isLoginError) {
      toast.error(loginErrorMessage, {
        position: "top-center",
      });
    }
  }, [isLoginSuccess, isLoginError, loginErrorMessage, dispatch, navigate]);

  useEffect(() => {
    return () => {
      dispatch(resetUserLogin());
    };
  }, [dispatch]);

  // handlers
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userName !== "" && password !== "") {
      dispatch(loginUser({ userName, password }));
    } else {
      toast.error("Username and Password is Required!", {
        position: "top-center",
      });
    }
  };

  return (
    <Container className="mt-3" style={{ flex: "none" }}>
      <Form onSubmit={handleSubmit}>
        <h1 className="text-center" style={{ fontWeight: "bold" }}>
          {" "}
          Login{" "}
        </h1>

        <Row className="">
          <Col lg={3} md={3}></Col>
          <Col lg={6} md={6}>
            <Row>
              <Form.Group className="mt-4">
                <Form.Label style={{ fontWeight: "bold" }}>
                  User Name
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Enter User Name"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="mt-3">
                <Form.Label style={{ fontWeight: "bold" }}>Password</Form.Label>
                <Form.Control
                  required
                  type={showPassword}
                  placeholder="Enter Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className="mt-3" controlId="showPassword">
                <Form.Check
                  type="checkbox"
                  label="Show Password"
                  onChange={(e) =>
                    setShowPassword(e.target.checked ? "text" : "password")
                  }
                />
              </Form.Group>
            </Row>

            <Row className="px-2 pt-4">
              <Button type="submit" className="rounded">
                Login
              </Button>
            </Row>
          </Col>
          <Col lg={3} md={3}></Col>
        </Row>
      </Form>
    </Container>
  );
};

export default LoginScreen;
